export default {
    name: 'Calendar7',
    dimensions: { width: 20, height: 23 },
    content: `
    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="1" y="3.25" width="18" height="18" rx="2"/>
      <path d="M1 7.25H19"/>
      <path d="M8 11.25H12L9 17.25"/>
      <path d="M5 1.25V2.75"/>
      <path d="M15 1.25V2.75"/>
    </g>
  `
};
